import React,{Component} from "react";
import Aux from "./HOC/Aux";
import {withRouter} from "react-router-dom";
import {FaChevronUp, FaChevronDown , FaTrash , FaEye} from "react-icons/fa";

class CartMobile extends Component{
  
    state={
        nights: 1,
        currentPrice: 0
    
}
componentDidMount=()=>{
    this.setState({
        currentPrice: this.props.room.price
    });
}
render(){
    const {name, price , capacity, size, images, slug, id} = this.props.room;

    const handlePriceChange=(method)=>{
        if(method === "increase" && this.state.nights < 10){
            this.setState(function (prevState){
                return{
                   nights: prevState.nights +1,
                    currentPrice: prevState.currentPrice  + this.props.room.price 
                }
                
            });
        }else if(method === "decrease" && this.state.nights >1){
            this.setState( prevState =>({
                nights: prevState.nights - 1,
                currentPrice: prevState.currentPrice - this.props.room.price
            }));
        }
        setTimeout(()=>{
            this.props.accumulator(this.state.currentPrice, id );
        },300);
        
    }
    const redirectToSingleRoom=()=>{
        this.props.history.push(`/rooms/${slug}#top`);
    }
        return(
            <Aux>
                <div className="cart-mobile-container">
                    <img className="cart-mobile-img" src={images[0]} alt={name}/>
                    <div style={{display:"block"}}>
                        <h4 style={{textTransform: "capitalize"}}>{name}</h4>
                        <p>Size : {size} SQFT</p>
                        <p>Price : ${price}</p>
                        <p className="mb-0">Capacity : {capacity} {capacity > 1 ? "people" : "person"}</p>
                        <div className="cart-mobile-price-cotainer">
                            Current Price : <span className="cart-mobile-price">${this.state.currentPrice}</span>
                            <div className="cart-nights mb-3">
                                <button onClick={()=> handlePriceChange("increase") } ><FaChevronUp/></button>
                                    {this.state.nights}
                                <button onClick={()=> handlePriceChange("decrease")}><FaChevronDown/></button>
                            </div>
                        </div>
                        <span className="cart-delete-Btn" onClick={()=> this.props.deleteRoom("cartRooms", id, this.props.index)}><FaTrash style={{color:"red"}} className="mb-2"/> Delete</span>                        
                        <span className="cart-delete-Btn mr-2" onClick={()=> redirectToSingleRoom()}><FaEye className="mb-2"/> Show more details</span>
                        
                    </div>
                    
                </div>
            </Aux>
        )
    }
}

export default withRouter(CartMobile);